export default "__VITE_ASSET__b41ef389__"